export default "__VITE_ASSET__2Cf8YhqW__"